import { Button } from "@mui/material";
import { useNavigate, useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  console.error(error);

  return (
    <div
      id="error-page"
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "20px",
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
      }}
    >
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
      <Button variant="contained" onClick={() => navigate("/")}>
        Go Home
      </Button>
    </div>
  );
}
